import { configureStore } from '@reduxjs/toolkit'

// Reducer valido per evitare l'errore "Store does not have a valid reducer"
// Un reducer deve sempre restituire uno stato valido (non undefined)
const appReducer = (state = { initialized: true }, action) => {
    // Gestisce tutte le azioni, restituendo sempre lo stato corrente o quello di default
    switch (action?.type) {
        default:
            return state;
    }
}

const store = configureStore({
    reducer: {
        app: appReducer,
    },
    middleware: (getDefaultMiddleware) => 
        getDefaultMiddleware({
            serializableCheck: false,
        }),
    devTools: process.env.NODE_ENV !== 'production',
})

export default store
